import React from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import './NewDashboard.css';
import { connect } from 'react-redux';
import { sessionCheck, fetchUserSuccess, startTrial } from '../actions/user';
import { showDialog } from '../actions/dialog';
import User from '../models/User';
import { TopBarVisibility } from '../components/layout/TopBarVisibility';
import NewCardList from './NewCardList.jsx';
import { DetailsView } from './DetailsView';
import { handleErrorWithDialog } from '../util/Errors';
import { NavigationUtils } from '../util/NavigationUtils';
import Event from '../models/Event';
import { GLOBAL_PATH_PREFIX, BETA_NEW_DASHBOARD } from '../constants';
import copy from 'clipboard-copy';
import { notify } from 'react-notify-toast';
import Logger from '../util/Logger';
import LoadingAndPulse from '../components/shared/LoadingAndPulse';
import { eventApi } from '../api/EventApi';
import PayMeModal from '../money/PayMeModal';
import _ from 'lodash';
import $ from 'jquery';
import { accountApi } from '../api/AccountApi';
import { BaseDialog } from '../components/layout/Dialog';
import { collectionApi } from '../api/CollectionApi';
import { ScreenRecorder } from '../util/ScreenRecorder';
import { BrowserChecker } from '../BrowserChecker';
import licensing from 'src/images/licensing.svg'
import DashboardModal from './DashboardModal';
import { DialogModalWindow, NameDialog } from '../components/shared';
import {
  tabFilters,
  toggleTabs,
  defaultFilters as staticDefaultFilters,
  defaultSortFn,
  introCards,
  TABS,
} from './newDashboardUtils';
import { authApi } from 'src/api/AuthApi';
import store from 'src/store/configureStore';
import { logout } from 'src/actions/logout';
import { TrackingAnalytics } from '../analytics/TrackingAnalytics';
import {
  StartTrialModal,
  TrialExpiredModal,
  TabsAndSearch,
  TitleAndToggle,
  TrialSignupBanner,
  GuestModal,
} from './shared';
import { withPayWall } from '../components/PayWall';
import { usePlan, PLAN } from '../components/PayWall/utils';
import AnnouncementBannerList from 'src/components/announcement/AnnouncementBannerList';

const WIDTH_IS_DESKTOP = 1192;
const isDesktopWindow = () => {
  return $(window).width() >= WIDTH_IS_DESKTOP;
};

export const HistoryContext = React.createContext({});
export const PayWallContext = React.createContext({});

const DEFAULT_SHOW_IDX = 0; // All Activity

class NewDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.getDefaultFilters = this.getDefaultFilters.bind(this);
    this.state = {
      isLargeWindow: isDesktopWindow(),
      isExampleMode: false,
      eventCache: {},
      exampleEvents: [],
      events: this.props.events || [],
      selected: null,
      showPayMeMoney: null,
      isInBeta: false,
      showDeleteModal: null,
      showMine: true,
      showOthers: true,
      searchValue: '',
      activityTabIndex: 0,
      isDashboardModalOpen: false,
      isGuestUserModalOpen: false,
      isRestrictedModalOpen: false,
      isNameDialogOpen: false,
      isTrialExpiredModalOpen: false,
      isStartTrialModalOpen: false,
      modalSourceIdx: 0,
      defaultFilters: this.getDefaultFilters(props),
      filters: {},
      sortFn: defaultSortFn,
    };
  }

  onHideModal = () => {
    this.setState({ showPayMeMoney: null });
  };

  getDefaultFilters = (props) => {
    const { location } = props;
    if (location.search) {
      const filters = this.getFiltersFromQuery(location.search);
      return filters;
    }
    return staticDefaultFilters;
  };

  componentDidMount() {
    const { sessionCheck } = this.props;
    sessionCheck(false);

    $(window).resize(this.resizeWindow);

    accountApi.getClientInfo().then((stash) => {
      const isInBeta = !!stash && !!stash[BETA_NEW_DASHBOARD];
      this.setState({ isInBeta });
    });
  }

  componentDidUpdate = (prevProps) => {
    const { events, user } = this.props;
    const { defaultFilters } = this.state;

    if (!prevProps.user && user && user.guest && !defaultFilters.toggle) {
      defaultFilters.toggle = toggleTabs[DEFAULT_SHOW_IDX];
    }

    // Default to "Joined" when user has not launched any session
    if (user && !user.has_self_launched) {
      defaultFilters.toggle = toggleTabs[1];
    }

    if (prevProps.events !== events) {
      this.setState({ events });
      this.filterEvents();
    }
  };

  componentWillReceiveProps(nextProps) {
    const { user } = nextProps;
    if (user) {
      this.setState({ isTrialExpiredModalOpen: this.isUserPlanExpired(user) });
    }
  }

  componentWillUnmount() {}

  resizeWindow = () => {
    this.setState({ isLargeWindow: isDesktopWindow() });
  };

  isPopinBlocked = () => {
    const { user } = this.props;
    if (!user) {
      return true;
    }

    if (_.get(user, 'plan.id') === 'free') {
      const { events } = this.state;
      if (events && events.filter((e) => Event.isUserCreated(e)).length >= 3) {
        return true;
      }
    }

    return false;
  };

  handleShowMine = (enable) => {
    this.setState({ showMine: enable });
  };

  handleShowOthers = (enable) => {
    this.setState({ showOthers: enable });
  };

  handleLeaveBeta = () => {
    accountApi.updateClientInfo(BETA_NEW_DASHBOARD, false).then(() => {
      NavigationUtils.routeToLegacy('/dashboard');
    });
  };

  handleLaunchClicked = () => {
    Logger.info('Launch clicked');
    if (this.isPopinBlocked()) {
      this.setState({ showPayMeMoney: 'launch' });
    } else {
      NavigationUtils.routeToLegacy('/q/edit');
    }
  };

  handleSurveyClicked = () => {
    Logger.info('Survey clicked');
    NavigationUtils.routeToLegacy('/q/edit');
  };

  handlePrioritizeClicked = () => {
    Logger.info('Prioritize clicked');
    NavigationUtils.openTab('/r/p/create');
  };

  handleHelpClicked = () => {
    NavigationUtils.openTab('https://support.popinnow.com');
  };

  handleBrandClicked = () => {
    const { history } = this.props;
    history.push('/r/branding');
  };

  handleUpgrade = () => {
    const { user } = this.props;
    if (user.plan.id === 'free') {
      // Extra hack tastic
      this.setState({ showPayMeMoney: 'upgrade' });
    } else {
      NavigationUtils.routeToLegacy('/manage-subscription');
    }
  };

  handleCopy = (event) => {
    // Extra hack tastic
    if (this.isPopinBlocked()) {
      this.setState({ showPayMeMoney: 'copy' });
    } else {
      NavigationUtils.routeToLegacy(`/q/${Event.getSlug(event)}/edit?copy=1`);
    }
  };

  handleDelete = (event) => {
    this.setState({ showDeleteModal: event });
  };

  deleteEvent = () => {
    const { showDeleteModal } = this.state;
    if (!!showDeleteModal) {
      this.onHideDeleteModal();

      TrackingAnalytics.send(`Dashboard - Delete Confirmation Clicked`);

      if (showDeleteModal.sample) {
        accountApi
          .updateClientInfo(
            `HIDE_SAMPLE_EVENT_${showDeleteModal.sampleId}`,
            true
          )
          .then(() => {
            this.onEventDeleted(showDeleteModal);
          })
          .catch((error) => {
            Logger.error('Failed to delete event: ', error);
          });
      } else {
        const collectionId = Event.getCollectionId(showDeleteModal);
        if (!!collectionId) {
          collectionApi
            .deleteCollection(collectionId)
            .then(() => {
              this.onEventDeleted(showDeleteModal);
            })
            .catch((error) => {
              Logger.error('Failed to delete event: ', error);
            });
        } else {
          eventApi
            .deleteEvent(Event.getId(showDeleteModal))
            .then(() => {
              this.onEventDeleted(showDeleteModal);
            })
            .catch((error) => {
              Logger.error('Failed to delete event: ', error);
            });
        }
      }
    }
  };

  onHideDeleteModal = () => {
    this.setState({ showDeleteModal: null });
    TrackingAnalytics.send(`Dashboard - Delete Cancel Clicked`);
  };

  onEventDeleted = (event) => {
    if (!event) {
      return;
    }

    const { events } = this.state;
    let index = -1;
    for (let i = 0; i < events.length; ++i) {
      const e = events[i];
      if (Event.getId(e) === Event.getId(event)) {
        index = i;
        break;
      }
    }

    if (index >= 0) {
      events.splice(index, 1);
      this.setState({ events, selected: null });
    }
  };

  handleNavigateToEvent = (event) => {
    if (event.sample) {
      this.handleLaunchClicked();
    } else {
      TrackingAnalytics.send(`Dashboard - Event Card Clicked`);
      if (Event.isClosed(event) && !BrowserChecker.isMobile()) {
        const { history } = this.props;
        history.push(`${GLOBAL_PATH_PREFIX}/q/${Event.getSlug(event)}/answers`);
      } else {
        NavigationUtils.routeToLegacy(`/q/${Event.getSlug(event)}/answers`);
      }
    }
  };

  handleEditEvent = (event) => {
    if (Event.isUserCreated(event)) {
      const { history } = this.props;
      TrackingAnalytics.send(`Dashboard - Event Edit Clicked`);
      history.push(`${GLOBAL_PATH_PREFIX}/${Event.getSlug(event)}/edit`);
    }
  };

  handlePresentEvent = (event) => {
    NavigationUtils.openTab(
      `${GLOBAL_PATH_PREFIX}/q/${Event.getSlug(event)}/present`
    );
  };

  handleShareEvent = (event) => {
    const shareLink = Event.getShareLink(event);
    if (!!shareLink) {
      copy(shareLink)
        .then(() => {
          notify.show('Copied share link to clipboard!', 'success', 1000);
        })
        .catch(() => {
          notify.show(
            'Failed to copy share link to clipboard!',
            'warning',
            1000
          );
        });
    }
  };

  handleInviteEvent = (event) => {
    const slug = Event.getSlug(event);
    if (!!slug) {
      NavigationUtils.routeToLegacy(
        `/q/${slug}/answers?fromreport=1&addpeople=1`
      );
    }
  };

  handleSelected = (selected) => {
    const clearSelected = () => {
      this.setState({ selected: null });
      this.props.history.replace({ search: '' });
    };

    const setSelected = (selected) => {
      this.setState({ selected });
      this.props.history.replace({
        search: `?selected=${Event.getId(selected)}`,
      });
    };

    if (!selected) {
      clearSelected();
      return;
    }

    const oldSelected = this.state.selected;
    if (!oldSelected) {
      setSelected(selected);
      return;
    }

    if (oldSelected.id === selected.id) {
      // Clear if they select again
      // clearSelected();
    } else {
      setSelected(selected);
    }
  };

  handleExampleModeChanged = (example) => {
    if (this.state.isExampleMode !== example) {
      this.setState({ isExampleMode: example }, () => {
        this.handleSelected(null);
      });
    }
  };

  logoutUser = ($event) => {
    $event.preventDefault();
    $event.stopPropagation();

    TrackingAnalytics.send(`Dashboard - Guest Log out Clicked`);

    Logger.info('LOGGING OUT');

    // Make sure the actual call succeeds, just incase store clear does not kick us out
    authApi
      .logout()
      .then(() => {
        Logger.info('Logout complete, back to POPin');
        NavigationUtils.backToPopin(true);
        store.dispatch(logout());
      })
      .catch((err) => {
        Logger.error(err);
        Logger.warn('Logout error, back to POPin anyway');
        NavigationUtils.backToPopin(true);
        store.dispatch(logout());
      });
  };

  toSignUp = ($event) => {
    const { history } = this.props;
    $event.preventDefault();
    $event.stopPropagation();
    TrackingAnalytics.send(`Dashboard - Guest Sign Up Clicked`);
    history.push('/r/signup');
  };

  filteredEvents = (events) => {
    return events
      .filter((e) => {
        if (!!e.user_created) {
          return !!this.state.showMine;
        } else {
          return true;
        }
      })
      .filter((e) => {
        if (!e.user_created) {
          return !!this.state.showOthers;
        } else {
          return true;
        }
      });
  };

  handleProfileClick = () => {
    NavigationUtils.routeToLegacy('/settings');
  };

  handleLearnMoreClick = () => {
    this.setState({ isDashboardModalOpen: true });
  };

  filterEvents = (newFilters = null, sortFn = this.state.sortFn) => {
    let filters = this.getFilters(newFilters);

    const { events = [] } = this.props;
    let filteredEvents = [...events];

    if (newFilters) this.setFiltersURL(filters);

    try {
      Object.values(filters).forEach(({ lambda }) => {
        filteredEvents = filteredEvents.filter(lambda);
      });
      filteredEvents = filteredEvents.sort(sortFn);
    } catch (error) {
      console.log('error', error);
      return;
    }

    this.setState({ filters, sortFn, events: filteredEvents });
  };

  getFilters = (newFilters) => {
    console.log('newFilters', newFilters);
    if (!newFilters && this.props.location.search) {
      const result = this.getFiltersFromQuery(this.props.location.search);
      return result;
    } else if (!newFilters) {
      return { ...this.state.filters };
    }
    return { ...this.state.filters, ...newFilters };
  };

  getFiltersFromQuery = (URLParamsStr = '') => {
    if (URLParamsStr) {
      const params = new URLSearchParams(URLParamsStr.slice(1));
      let filters = {};

      for (const [key, val] of params.entries()) {
        const tabFltr = tabFilters.find(({ id }) => id === key);
        let filterObj = {};

        if (tabFltr) {
          filterObj = tabFltr.options.find(({ id }) => id === val);
        } else if (key === 'toggle') {
          filterObj = toggleTabs.find(({ id }) => id === val);
        }

        filters[key] = filterObj;
      }
      return filters;
    }

    return {};
  };

  setFiltersURL = (filters) => {
    const { history, location } = this.props;
    const params = new URLSearchParams(location.search.slice(1));

    try {
      Object.entries(filters).forEach(([filterId, { id }]) => {
        params.set([filterId], id);
      });

      history.push(location.pathname + '?' + params.toString());
    } catch (error) {
      console.log('error', error);
      return;
    }
  };

  showGuestUserModal = () => {
    this.setState({ isGuestUserModalOpen: true });
  };

  onCreatePrioritizeClick = () => {
    const { history } = this.props;
    history.push('/r/p/create');
  };

  onCreateCrowdsourceClick = () => {
    const { history } = this.props;
    history.push('/r/crowdsource/create');
  };

  onCreateSurveyClick = () => {
    const { history } = this.props;
    history.push('/r/survey/create');
  };

  onClickMap = {
    prioritize: this.onCreatePrioritizeClick,
    crowdsource: this.onCreateCrowdsourceClick,
    survey: this.onCreateSurveyClick,
  };

  onCreateClick = (id) => {
    if (this.props.user.event_creation_allowed) {
      (this.onClickMap[id] || (() => {}))();
    } else {
      this.setState({ isRestrictedModalOpen: true });
    }
  };

  onIntroLearnMoreClick = (title, idx) => () => {
    TrackingAnalytics.send(`Dashboard - Learn More Clicked`, {
      product: title,
    });
    this.setState({ isDashboardModalOpen: true, modalSourceIdx: idx });
  };

  mapPlanToModal = {
    guest: () => this.setState({ isGuestUserModalOpen: true }),
    expired: () => this.setState({ isTrialExpiredModalOpen: true }),
    participant: () => this.setState({ isStartTrialModalOpen: true }),
  };

  isUserPlanExpired = (user) => {
    const { expiration } = user.plan;
    const result = moment().isAfter(moment.unix(expiration));
    return result;
  };

  onIntroCreateClick = (id, title) => () => {
    TrackingAnalytics.send(`Dashboard - Create Clicked`, { product: title });
    this.onCreateClick(id);
  };

  isBannerShown = (user) => {
    const { getPlanType } = usePlan();
    const plan = getPlanType(user);
    return plan === PLAN.guest || plan === PLAN.participant;
  };

  renderLaunchAndList = (isDesktop) => {
    const { location, history, user, usePayWall } = this.props;
    const {
      events,
      exampleEvents,
      selected,
      isExampleMode,
      // isInBeta,
      // showMine,
      // showOthers,
      // searchValue
      isDashboardModalOpen,
      isGuestUserModalOpen,
      isRestrictedModalOpen,
      isNameDialogOpen,
      isTrialExpiredModalOpen,
      isStartTrialModalOpen,
      modalSourceIdx,
      sortFn,
      defaultFilters,
      filters,
    } = this.state;
    const cardList = this.filteredEvents(
      isExampleMode ? exampleEvents : events
    ).sort(sortFn);

    const withPayWall = usePayWall();
    const isBannerShown = this.isBannerShown(user);

    return (
      <React.Fragment>
        <HistoryContext.Provider value={history}>
          {/* Announcement banners visible to all dashboard users - displayed at top, outside intro container */}
          <AnnouncementBannerList />
          {isBannerShown && (
            <TrialSignupBanner onClick={() => history.push('/r/signup')} />
          )}

          <div className="intro-section-wrapper">
            <h2 className="heading get-started">Launch a POPin</h2>
            <div className="intro_section">
              {introCards.map(({ id, title, icon, text }, idx) => (
                <div
                  key={title}
                  className="col intro_card prioritize-container"
                >
                  <h2 className="heading">{title}</h2>
                  <div className="row content">
                    <div className="col-3 icon_wrapper">
                      <img src={icon} alt="icon" />
                    </div>
                    <div className="col-9">{text}</div>
                  </div>
                  <button
                    onClick={withPayWall(this.onIntroCreateClick(id, title))}
                    style={{ boxShadow: 'none' }}
                    className="w-100 btn btn-lg btn-primary btn-submit"
                  >
                    + Create a {title} Session
                  </button>
                  <span
                    onClick={this.onIntroLearnMoreClick(title, idx)}
                    className="w-100 learn-more"
                  >
                    Learn more
                  </span>
                </div>
              ))}
              <DashboardModal
                isOpen={isDashboardModalOpen}
                onClose={() => this.setState({ isDashboardModalOpen: false })}
                card={introCards[modalSourceIdx]}
                onClick={(id, title) =>
                  withPayWall(this.onIntroCreateClick(id, title))()
                }
                usages={introCards[modalSourceIdx].usages}
                history={history}
                user={user}
                onSignUp={this.toSignUp}
                onLogout={this.logoutUser}
              />

              <GuestModal
                isOpen={isGuestUserModalOpen}
                onSignUp={this.toSignUp}
                onLoguot={this.logoutUser}
                onCancel={() => this.setState({ isGuestUserModalOpen: false })}
              />

              <DialogModalWindow
                isOpen={isRestrictedModalOpen}
                cancelBtn={false}
                confirmBtn={false}
                onCancel={() => this.setState({ isRestrictedModalOpen: false })}
              >
                <div className="guest-modal">

                  <div>
                    <img src={licensing} alt="Licensing" width="100" style={{ width: '75px', marginBottom: 20 }}/>
                  </div>

                  Sorry! Your Administrative Account Owner has restricted POPin creation to authorized users only.
                  Here's what you can do:<br/><br/>

                  <ul>
                    <li>Reach out to your named POPin administrator: {user && user.tenant && user.tenant.owner ? user.tenant.owner.email : 'Contact us'}</li>
                    <li>Use the live Help chat to engage our support team for assistance</li>
                  </ul>
                </div>
              </DialogModalWindow>

              <NameDialog
                isOpen={isNameDialogOpen}
                onCancel={() => this.setState({ isNameDialogOpen: false })}
                onSaveName={() => this.setState({ isNameDialogOpen: false })}
              />

              <StartTrialModal
                isOpen={isStartTrialModalOpen}
                onCancel={() => this.setState({ isStartTrialModalOpen: false })}
              />
              <TrialExpiredModal
                isOpen={isTrialExpiredModalOpen}
                onCancel={() =>
                  this.setState({ isTrialExpiredModalOpen: false })
                }
                onSubmit={() => {}}
              />
            </div>
          </div>

          <div className="prioritize-container my_activity">
            <div className="header">
              <TitleAndToggle
                defaultFilters={defaultFilters}
                updateEvents={this.filterEvents}
              />
              <TabsAndSearch
                defaultFilters={defaultFilters}
                onChange={this.filterEvents}
                updateEvents={this.filterEvents}
                tabs={TABS}
              />
            </div>
            <PayWallContext.Provider
              value={{ onChange: (action) => withPayWall(action)() }}
            >
              <div className="cardlist_container">
                <NewCardList
                  events={cardList}
                  location={location}
                  selected={selected}
                  isDesktop={isDesktop}
                  user={user}
                  handleSelected={this.handleSelected}
                  isExampleMode={isExampleMode}
                  handleCopy={this.handleCopy}
                  handleDelete={this.handleDelete}
                  filters={filters}
                  handleUpdateEvents={(e, callback) => {
                    const payload = {};
                    if (isExampleMode) {
                      payload.exampleEvents = e;
                    } else {
                      payload.events = e;
                    }
                    this.setState(payload, callback);
                  }}
                />
              </div>
            </PayWallContext.Provider>
          </div>
        </HistoryContext.Provider>
      </React.Fragment>
    );
  };

  componentDidUpdate(prevProps) {
    const { user, userError } = this.props;
    if (!prevProps.user && !!user) {
      ScreenRecorder.record(false);
    }

    if (userError) {
      handleErrorWithDialog(
        userError,
        prevProps.userError,
        'Unable to load your Account, please try again later'
      );
    }
  }

  render() {
    const { user, history, userError } = this.props;
    const {
      showPayMeMoney,
      selected,
      isLargeWindow,
      /*eventCache,*/ showDeleteModal,
    } = this.state;

    if (!user && userError) {
      NavigationUtils.routeToLegacy('/signin');
    }

    if (!user) {
      return (
        <div className="col h-100 w-100 d-flex">
          <div className="m-auto col">
            <LoadingAndPulse size={20} color="#3D9AE2" />
          </div>
        </div>
      );
    }

    const planName = _.get(user, 'plan.name') || 'Plan';
    const payUpsell =
      showPayMeMoney === 'upgrade'
        ? ``
        : `Your ${planName} is limited to 3 POPins per user`;
    return (
      <div
        className={`${isLargeWindow ? 'row' : 'col'}
          w-100 px-0 mx-0 h-100
          allow-scrolling
          ${this.getContainerClass()}
          ${isLargeWindow ? 'new-dashboard-desktop' : 'new-dashboard-mobile'}
          ${!isLargeWindow && selected ? 'color-background-mobile' : ''}
        `}
      >
        {/* Launch and List */}
        {isLargeWindow ? (
          <div className="no-gutters main-container h-100">
            {/* <div className="col h-100 w-100 "> */}
            {/* <div className="right-padding"> */}
              {this.renderLaunchAndList(user, true)}
            {/* </div> */}
            {/* </div> */}
          </div>
        ) : (
          <div className="">{this.renderLaunchAndList(user, false)}</div>
        )}

        {/* Deets */}
        {/* { isLargeWindow
          ? (
            <div className="col-7 no-gutters h-100">
              { this.renderDetailsView(user, selected, eventCache, true) }
            </div>
            )
          : this.renderDetailsView(user, selected, eventCache, false)
        } */}

        {/* <RightPanel
          history={history}
          user={user}
          onGuestUserCreate={this.showGuestUserModal}
        /> */}

        {!!showPayMeMoney && (
          <PayMeModal
            user={user}
            upsell={payUpsell}
            openedFrom={
              showPayMeMoney === 'launch'
                ? 'Free POPin Limit Reached'
                : showPayMeMoney === 'upgrade'
                ? 'Upgrade Manually Clicked'
                : 'Free POPin Copy Limit Reached'
            }
            onHidden={this.onHideModal}
          />
        )}

        {!!showDeleteModal && (
          <BaseDialog
            show={true}
            closeOnClickOutside={true}
            customModalDialogClass="new-dashboard-delete-modal"
            body={
              <div className="col no-gutters">
                <div className="row no-gutters mb-3">
                  <i
                    style={{ background: 'red', color: 'white' }}
                    className="material-icons m-auto rounded-circle p-2"
                  >
                    delete
                  </i>
                </div>
                <h1 className="text-center mb-3">Delete this POPin?</h1>
                <div className="row no-gutters mt-3">
                  <span className="text-center">
                    You will permanently lose access to its questions and
                    responses.
                  </span>
                </div>
                <div className="row no-gutters mt-3">
                  <button className="btn" onClick={this.onHideDeleteModal}>
                    Cancel
                  </button>
                  <div className="col" />
                  <button className="btn btn-danger" onClick={this.deleteEvent}>
                    Delete
                  </button>
                </div>
              </div>
            }
            hideDialog={this.onHideDeleteModal}
          />
        )}
      </div>
    );
  }

  renderDetailsView = (user, selected, eventCache, isDesktop) => {
    return (
      <DetailsView
        handleEditClick={this.handleEditEvent}
        handlePresentClick={this.handlePresentEvent}
        handleShareClick={this.handleShareEvent}
        handleInviteClick={this.handleInviteEvent}
        handleGoClick={this.handleNavigateToEvent}
        handleClose={() => this.handleSelected(null)}
        isDesktop={isDesktop}
        eventCache={eventCache}
        handleUpdateEventCache={(cache, callback) =>
          this.updateEventCache(cache, callback)
        }
        user={user}
        event={selected}
      />
    );
  };

  updateEventCache = (cache, callback) => {
    this.setState({ eventCache: cache }, callback);
  };

  getContainerClass = () => {
    const { user } = this.props;
    let viewing = null;
    if (user) {
      if (TopBarVisibility.isViewingAs(user)) {
        viewing = User.getEmail(user) || 'Not Available';
      }
    }
    return !!viewing ? 'new-dashboard-viewing-as' : 'new-dashboard';
  };
}

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
    userError: state.user.error,
    events: state.event.events,
  };
};

export default withRouter(
  withPayWall()(
    connect(mapStateToProps, {
      sessionCheck,
      fetchUserSuccess,
      showDialog,
    })(NewDashboard)
  )
);
